import { Dayjs } from "dayjs";

export const getCustomWeek = (date: Dayjs) => {
  const startOfYear = date.startOf("year").startOf("week");
  return Math.ceil(date.diff(startOfYear, "week", true));
};

export const getWeekRange = (date: Dayjs): [Dayjs, Dayjs] => [
  date.startOf("week"),
  date.endOf("week"),
];
